import {queryClient} from '@api'
import translationDe from '@translations/de.json'
import translationDk from '@translations/dk.json'
import translationEn from '@translations/en.json'
import translationFi from '@translations/fi.json'
import translationFr from '@translations/fr.json'
import translationNl from '@translations/nl.json'
import translationNo from '@translations/no.json'
import translationSe from '@translations/se.json'

import React from 'react'

import {QueryClientProvider} from '@tanstack/react-query'
import i18next from 'i18next'
import ReactDOM from 'react-dom/client'
import {initReactI18next} from 'react-i18next'

import App from './App'
import './index.css'
import reportWebVitals from './reportWebVitals'

// i18n setup
i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  saveMissing: false,
  missingKeyHandler: false,
  debug: false,
  resources: {
    en: {translation: translationEn},
    se: {translation: translationSe},
    de: {translation: translationDe},
    dk: {translation: translationDk},
    no: {translation: translationNo},
    nl: {translation: translationNl},
    fr: {translation: translationFr},
    fi: {translation: translationFi},
  },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  // <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  // </React.StrictMode>,
)

// Web vitals
reportWebVitals()
